import { ServerConnection } from "src/server/serverConnection";
import { IFileDownloader } from "src/uicomponents/components/fileSelector/fileSelector-viewModel";

export class InvoiceAttachmentDownloader implements IFileDownloader{
    async download(fileId: string, filename: string): Promise<{ name: string; content: string; }> {
        let result = await ServerConnection.callServer('/Complex/ImportProductServices/GetInvoiceAttachmentFile',{
            FileId:fileId
        });
        return {name:filename,content:result.Content}
    }
}